import moment from 'moment-business-days'

const contactBack = () => {
  const nextDate = moment(new Date().toLocaleDateString(), 'MM-DD-YYYY').businessAdd(2)._d
  return moment(nextDate).format('dddd, MMMM D, YYYY')
}

export default contactBack
